import { render, staticRenderFns } from "./dedicated-setting.vue?vue&type=template&id=4e91de2e"
import script from "./dedicated-setting.vue?vue&type=script&lang=js"
export * from "./dedicated-setting.vue?vue&type=script&lang=js"
import style0 from "./dedicated-setting.vue?vue&type=style&index=0&id=4e91de2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports